import * as BABYLON from "babylonjs"
import * as GUI from "babylonjs-gui"

export class Button {
	static create(
		scene: BABYLON.Scene,
		id: string,
		position: [number, number, number],
		size: [number, number], // [width, height]
		text: string,
		imageUrl: string,
		imageUrl1: string,
		onClick: () => void,
		bgColour: string = "blue",
		textColour: string = "green",
		grabbable: boolean,
		visibility: boolean,
		parentID?: string // New parameter for parent ID
	): void {
		// Create a plane to act as the button
		const plane = BABYLON.MeshBuilder.CreatePlane(
			id,
			{ width: size[0], height: size[1] },
			scene
		)
		plane.position = new BABYLON.Vector3(position[0], position[1], position[2])

		// Create an advanced texture for this plane
		const advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(
			plane,
			1024,
			512
		)

		// Create the main button that will act as the dropdown header
		const button = GUI.Button.CreateSimpleButton(`UI_${id}_button`, text)
		const image = new GUI.Image("image", imageUrl)

		button.width = "100%"
		button.height = "100%"
		button.color = textColour
		button.background = bgColour
		advancedTexture.addControl(button)
		advancedTexture.hasAlpha = true
		button.textBlock!.fontSize = "30%"
		button.textBlock!.fontWeight = "bold"
		button.textBlock!.fontFamily = "Nunito, sans-serif"
		button.cornerRadius = 200 // This property rounds the edges of the button
		button.thickness = 20 // Sets the thickness of the border
		if (imageUrl != "") {
			button.textBlock!.text = ""
			image.width = "100%" // Set the width of the image
			image.height = "100%" // Set the height of the image
			image.stretch = GUI.Image.STRETCH_FILL // Adjust the stretch mode as needed
			button.addControl(image) // Add the image control to the button
		}
		let isInitialImage = true // Toggle state

		function toggleImage() {
			if (isInitialImage) {
				image.source = imageUrl1
			} else {
				image.source = imageUrl
			}
			isInitialImage = !isInitialImage
		}

		// Bind toggle function to header button
		button.onPointerClickObservable.add(() => {
			onClick()
			if (imageUrl1 != "") {
				toggleImage()
			}
		})

		// Setting the parent if parentID is provided
		if (parentID) {
			const parentMesh = plane._scene!.getMeshByID(parentID) as BABYLON.Mesh
			if (parentMesh) {
				plane.parent = parentMesh
			}
		}
		if (grabbable) {
			// Instead of PointerDragBehavior, use SixDofDragBehavior for 3D dragging
			const dragBehavior = new BABYLON.SixDofDragBehavior()
			plane.addBehavior(dragBehavior)

			dragBehavior.onDragStartObservable.add(() => {
				console.log("3D dragging started")
			})
			// No onDragObservable here, SixDofDragBehavior does not provide continuous updates like PointerDragBehavior
			dragBehavior.onDragEndObservable.add(() => {
				console.log("3D dragging ended")
			})
		}
		plane.isVisible = visibility
		plane.renderingGroupId = 2
	}
}
